"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _calendar = _interopRequireDefault(require("cccisd-icons/calendar2"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross3"));
var _circleSmall = _interopRequireDefault(require("cccisd-icons/circle-small"));
var _CalendarDialog = _interopRequireDefault(require("./CalendarDialog"));
var _style = _interopRequireDefault(require("../style.css"));
var _excluded = ["updateSessionHeldStatus", "updateSessionDate", "handleCalendarSubmit", "renderFormat"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var DatePicker = function DatePicker(_ref) {
  var updateSessionHeldStatus = _ref.updateSessionHeldStatus,
    updateSessionDate = _ref.updateSessionDate,
    handleCalendarSubmit = _ref.handleCalendarSubmit,
    _ref$renderFormat = _ref.renderFormat,
    renderFormat = _ref$renderFormat === void 0 ? 'modal' : _ref$renderFormat,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(props.wasSessionHeld),
    _useState2 = _slicedToArray(_useState, 2),
    wasSessionHeld = _useState2[0],
    setWasSessionHeld = _useState2[1];
  var _useState3 = (0, _react.useState)(props.sessionDate),
    _useState4 = _slicedToArray(_useState3, 2),
    sessionDate = _useState4[0],
    setSessionDate = _useState4[1];
  function getHeldStatus() {
    if (wasSessionHeld === undefined) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "-- / -- / --");
    }
    if (wasSessionHeld === true) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].held
      }, /*#__PURE__*/_react["default"].createElement(_circleSmall["default"], null)), "Held: ", (0, _moment["default"])(sessionDate).format('MM/DD/YYYY'));
    }
    if (wasSessionHeld === false) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].missed
      }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)), "Missed");
    }
  }
  if (renderFormat === 'page') {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        paddingTop: '2rem'
      }
    }, /*#__PURE__*/_react["default"].createElement("hgroup", {
      style: {
        display: 'flex',
        justifyContent: 'center'
      }
    }, /*#__PURE__*/_react["default"].createElement("h3", null, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_calendar["default"], {
      spaceRight: true
    })), "Please Choose Session Status and Date:")), /*#__PURE__*/_react["default"].createElement(_CalendarDialog["default"], {
      sessionHeld: wasSessionHeld,
      selectedDate: sessionDate,
      changeSessionHeld: function changeSessionHeld(e) {
        return setWasSessionHeld(e);
      },
      onDateSelect: function onDateSelect(e) {
        return setSessionDate(e.startDate);
      },
      onCalendarSubmit: function onCalendarSubmit() {
        handleCalendarSubmit({
          wasSessionHeld: wasSessionHeld,
          sessionDate: sessionDate
        });
      }
    }));
  }
  if (renderFormat === 'modal') {
    return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      title: "Please Choose Session Status and Date:",
      size: "large",
      renderTrigger: function renderTrigger(_ref2) {
        var onClick = _ref2.onClick;
        return /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-lg btn-default",
          onClick: wasSessionHeld !== undefined && onClick
        }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_calendar["default"], {
          spaceRight: true
        }), " ", getHeldStatus()));
      }
    }, /*#__PURE__*/_react["default"].createElement(_CalendarDialog["default"], {
      sessionHeld: wasSessionHeld,
      selectedDate: sessionDate,
      changeSessionHeld: function changeSessionHeld(e) {
        return setWasSessionHeld(e);
      },
      onDateSelect: function onDateSelect(e) {
        return setSessionDate(e.startDate);
      },
      onCalendarSubmit: function onCalendarSubmit() {
        handleCalendarSubmit({
          wasSessionHeld: wasSessionHeld,
          sessionDate: sessionDate
        });
      }
    }));
  }
};
var _default = DatePicker;
exports["default"] = _default;